import {Column, Entity, OneToOne, PrimaryGeneratedColumn} from "typeorm"

export enum IpRangeType {
  Fixed = "FIXED", 
  Dynamic = "DYNAMIC"
}

@Entity()
export class IPRange {

	@PrimaryGeneratedColumn()
  id?: number
  
  @Column()
  rangeStart!: number

  @Column()
  rangeEnd!: number
	
  @Column()
  provider!: string
  
  @Column()
  type!: number

}